"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importDefault(require("react"));
const base_ui_modals_modal_1 = require("@unboared/base-ui.modals.modal");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
function Alert(props) {
    const { color } = props, rest = __rest(props, ["color"]);
    const theme = (0, base_ui_theme_themes_1.useTheme)();
    return (react_1.default.createElement(base_ui_modals_modal_1.Modal, Object.assign({}, rest, { color: color || theme.backgroundColor })));
}
exports.Alert = Alert;
//# sourceMappingURL=alert.js.map